
const sh = require('shelljs')
const { accent, newline } = require('common')

module.exports = yargs => {
	console.log(accent("ops size --\n"))

	const { stdout } = sh.exec(`git ls-files | grep -v 'libraries' | grep -v 'dist' | grep -v 'legacy' | grep -v '.md' | grep -v 'test' | grep -v '.svg' | grep -v '.png' | grep -v '.jpeg' | grep -v '.jpg' | xargs cat | wc -l`, {silent: true})
	console.log(`\t${stdout.trim()} lines of code`)
	newline()
}



// WEBPACK FOOTER //
// ./src/commands/size.js